import React from 'react';
import { CheckIcon, FileTextIcon, LockIcon, MailIcon, ShieldCheckIcon } from 'lucide-react';
import { HEALTH_DISCLAIMER, offer } from '../data/content';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
const includes = ['6 tomos principales en PDF', 'Ruta de hábitos de 15 días', '50 recetas sencillas', 'Los 5 bonos prácticos', "Formato digital"];
const assurances = [{
  icon: LockIcon,
  label: 'Pago seguro'
}, {
  icon: FileTextIcon,
  label: 'Archivos PDF'
}, {
  icon: MailIcon,
  label: 'Acceso por email'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía de 7 días'
}];
export function Offer() {
  return <section id="oferta" className="bg-white py-20 sm:py-28" aria-labelledby="oferta-title" style={{
    paddingTop: "50px",
    paddingBottom: "50px"
  }} data-id="element-163" data-mp="13ylzjbvsaqxa">
      <div className="mx-auto max-w-5xl px-6" data-id="element-164" data-mp="2fboey3m5dafv">
        <Reveal data-id="element-165" data-mp="2fad3dhmgmye7">
          <div className="text-center" data-id="element-166" data-mp="2fe0y2k3n5qui">
            <h2 id="oferta-title" className="font-display text-3xl leading-tight text-ink sm:text-4xl lg:text-[2.75rem]" data-id="element-167" data-mp="2adwdahvpa9yh">
              Megapack completo
            </h2>
            <p className="mt-4 text-lg text-ink-soft" data-id="element-168" data-mp="ujbr2hw2mt2f">
              Un único pack con todo el contenido. Sin versiones ni suscripciones.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.06} data-id="element-169" data-mp="zgk98ih7yx3o">
          <div className="mx-auto mt-12 max-w-3xl overflow-hidden rounded-3xl border border-mint-300 bg-white shadow-lift" data-id="element-170" data-mp="13ki6soqwbzum">
            <p className="bg-mint-600 px-4 py-2.5 text-center text-sm font-semibold text-white" data-id="element-171" data-mp="6v0s5k9xr3gs">
              {offer.label}
            </p>

            <div className="grid gap-10 p-8 sm:p-12 md:grid-cols-[minmax(0,1fr)_minmax(0,0.9fr)]" data-id="element-172" data-mp="bqg2i28qih8g">
              <div data-id="element-173" data-mp="fskuyxng57ti">
                <h3 className="font-display text-3xl text-ink" data-id="element-174" data-mp="kkvz6cp7zfrv">Qué incluye</h3>
                <ul className="mt-6 space-y-3" data-id="element-175" data-mp="kmyt37thtt1v">
                  {includes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-176" data-mp="3k8dmwz0ysrps">
                      <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-mint-600" aria-hidden="true" data-id="element-177" data-mp="3o95yw0181apr" />
                      <span className="text-[15px] text-ink-soft" data-id="element-178" data-mp="vepbh3odj7w8">{item}</span>
                    </li>)}
                </ul>
              </div>

              <div className="flex flex-col" data-id="element-179" data-mp="qetf9qlx4kr8">
                <p className="font-display leading-none text-mint-700" style={{
                fontSize: "56px"
              }} data-id="element-180" data-mp="154ijjupb54vq">
                  {offer.price}
                </p>
                <p className="mt-3 text-base font-medium text-ink" data-id="element-181" data-mp="cgczla62vjwy">Pago único</p>

                <div className="mt-8" data-id="element-182" data-mp="7hs05cynh49k">
                  <CtaButton className="w-full" size="md" data-id="element-183" data-mp="7itim2hzwt1b">{offer.ctaPrimary}</CtaButton>
                </div>

                <p className="mt-auto pt-6 text-xs leading-relaxed text-ink-muted" data-id="element-184" data-mp="lj4ddgmferrr">
                  {HEALTH_DISCLAIMER}
                </p>
              </div>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.04} data-id="element-185" data-mp="1wuwsdcigrr0j">
          <ul className="mx-auto mt-10 flex max-w-3xl flex-wrap justify-center gap-x-8 gap-y-3" data-id="element-186" data-mp="1sv4tjrivgz8d">
            {assurances.map(item => <li key={item.label} className="inline-flex items-center gap-2 whitespace-nowrap text-sm text-ink-muted" data-id="element-187" data-mp="20e49tob1eani">
                <item.icon className="h-4 w-4 text-mint-600" aria-hidden="true" data-id="element-188" data-mp="25es2sfitt1kd" />
                {item.label}
              </li>)}
          </ul>
        </Reveal>
      </div>
    </section>;
}